import { useState } from "react";
import { Input } from "../ui/input";

import { Button, InputLabel as Label } from "@mui/material";
import { Mail, Person as User } from "@mui/icons-material";
import PhoneInputWithCountry from "../ui/PhoneInputWithCountry";
import { createTrial } from "../../services/otp";
import { completeKwikLogin } from "../../services/auth";
import { emitSnackbar } from "../../lib/snackbar-emitter";
import { loader } from "../../lib/loader";
import manageErrors from "../../lib/error-management";

interface SessionData {
  name?: string
  email?: string
  telephone?: string
}

interface Step4Props {
  onNext: () => void
  restart: () => void
  sessionId: string | null
  sessionData: SessionData | null
}

const Step4CollaboratorData = ({ onNext, restart, sessionId, sessionData }: Step4Props) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false)

  const isValid = name.trim().length > 0 && email.includes("@") && phone.replace(/\D/g, "").length >= 12

  const finalizeProcess = async () => {
    if (!sessionId) {
      emitSnackbar({message: 'Sessão de validação inválida. Recomece o cadastro.', severity: 'error'})
      return
    }

    setLoading(true)
    loader.on()

    try {
      const response = await createTrial(sessionId, {
        name: name,
        email: email,
        telephone: phone.replace('+', '')
      })

      if (response.ok) {
        const data = response.data
        const loginResult = await completeKwikLogin(data)

        if (!loginResult.ok) {
          emitSnackbar({message: loginResult.error || 'Não foi possível concluir a autenticação.', severity: 'error'})
          return
        }

        onNext()
      } else {
        emitSnackbar({message: manageErrors(response.data), severity: 'error'})
      }
    } finally {
      setLoading(false)
      loader.off()
    }
  }

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-xl font-bold text-foreground mb-2">
          Configure seu primeiro número de WhatsApp
        </h1>
        <p className="text-sm text-muted-foreground">
          Convide um colaborador para monitorar
        </p>
        <Button style={{ marginTop: "1rem" }} size="small" variant="contained" onClick={() => {
          setName(sessionData?.name ?? "")
          setEmail(sessionData?.email ?? "")
          setPhone(sessionData?.telephone ?? "")
        }}>
          Eu mesmo vou testar
        </Button>
      </div>

      <div className="bg-card rounded-lg border border-border shadow-sm p-6 space-y-5">
        <div className="space-y-1.5">
          <Label htmlFor="collab-name" className="text-sm font-medium text-foreground">Nome do colaborador</Label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              id="collab-name"
              className="pl-10"
              placeholder="Nome do colaborador"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="collab-email" className="text-sm font-medium text-foreground">E-mail do colaborador</Label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              id="collab-email"
              type="email"
              className="pl-10"
              placeholder="colaborador@empresa.com.br"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="collab-phone" className="text-sm font-medium text-foreground">WhatsApp do colaborador</Label>
          <PhoneInputWithCountry
            id="collab-phone"
            value={phone}
            onChange={setPhone}
          />
        </div>
          <p className="text-center">
            <button type="button" className="text-center text-xs text-muted-foreground hover:underline"
            onClick={restart}>
              Recomeçar.
            </button>
          </p>

        <Button
          className="w-full"
          size="large"
          variant='contained'
          disabled={!isValid || loading}
          onClick={finalizeProcess}
        >
          {loading ? 'Aguarde':'Enviar convite'}
        </Button>
      </div>
    </div>
  );
};

export default Step4CollaboratorData;
